var Marionette = require('marionette'),
    Backbone = require('backbone'),
    BaseSidePanel = require('../panelCommon/paneViewBase');



module.exports = BaseSidePanel.extend({

    side: 'left',

    panelTemplate: require('./leftPanel.hbs'),

    ui: {
        indexes:        '.FV-indexes-panel',
        thumbNails:     '.FV-thumbnails-panel',
        findAndRedact:  '.FV-find-and-redact-panel'
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelLeft/leftPanelView.js
 ** module id = 745
 ** module chunks = 0
 **/